var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClient = function SvgClient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C0C5D2",
    d: "M21 4H3C1.3 4 0 5.3 0 7v11c0 1.7 1.3 3 3 3h18c1.7 0 3-1.3 3-3V7c0-1.7-1.3-3-3-3m1 14c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h18c.6 0 1 .4 1 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0C5D2",
    d: "M19 10h-7v2h7zM19 14h-7v2h7zM8 13H6c-1.1 0-2 .9-2 2v2h6v-2c0-1.1-.9-2-2-2M7 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4M9 3h2c0-.6.4-1 1-1s1 .4 1 1h2c0-1.7-1.3-3-3-3S9 1.3 9 3"
  })));
};
export default SvgClient;